import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'W10',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M23.27 23.27h-.77l2.61-3.21a5.82 5.82 0 0 0-1.84-11.34c-1.16 0-2.24.35-3.15.94-.9-3.87-4.35-6.76-8.48-6.76-4.82 0-8.73 3.91-8.73 8.73 0 3.96 2.64 7.3 6.26 8.37l-.98 2.75C3.44 21.28 0 16.86 0 11.64 0 5.21 5.21 0 11.64 0 16 0 19.8 2.41 21.79 5.97c.48-.08.97-.15 1.48-.15 4.82 0 8.73 3.91 8.73 8.73s-3.91 8.72-8.73 8.72zm-8.73-10.18h7.27l-4.36 7.27h5.09L13.09 32l2.62-8.73h-4.8l3.63-10.18z" }
      })]
    );
  }
};